import React, { useEffect } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { PDFDataAnalystViewWrapper } from 'dsilo-ui-components'
import { PDFDataAnalystViewWrapperV2 } from 'dsilo-ui-components'
import {
    clearSuccessMsg, createDocument, downloadContractPDFAction, downloadSheet, getContractDataById, getEventByID, getNotDuplicateAPI,
    updateContractAnnotations, getDataModelById, addComment, deleteContractPDFAction,
    getModelDataDropDown, initiateAction, updateDataModelData, getMembersList,
    addNewEntriesByDataModel, clearReduxDataOfCurrentComponent, getModelData, getAuditTrailsData,
    changeAssigneeRequest, completeReviewAction, getDataModels, otherDocMove, splitPDF, getVISData, getPDFForOtherDoc, hideSuccessMessage, rejectReviewAction, getWorkflow, finalDocument, getGroupsByMemberId, getNextRespondent, getNextTasks, executeWorkFlow, executeWorkFlowReject, lockDocument, unlockDocument,
    fetchmasterDataForDataelementUsingRules, getGroups, getSupportingDocuments, uploadSupportDocument,
    getOthersAuditTrailsData, moveToDuplicates, createDocumentTableData, getDocumentTablesDataById,
    updateDocumentTableData, deleteDocumentTableData, getLineItemsTablesData, getReviewInfo,
    executeRejectToQa, getPoInfoFromExternalSource, handleSageIntacct, getDocumentAnnotations,
    getCurrentStepRespondents, resolveIntegrationExceptions,
    reInitiateWorkflow, uploadLITableExcel, supportingDocMove, archivedData
} from '../../store/actions';

import { Loader } from "../loader";
import { PUBLIC_PATH } from '../../constants';

const PDFQAViewComponent = (props) => {
    // To avoid unwanted popups on list pages (when redirecting to list page from view page)
    useEffect(() => {
        return () => {
            props.clearReduxDataOfCurrentComponent({
                key: "message",
                subKey: []
            })
        }
    }, [])

    const dataServiceUrl = process.env.REACT_APP_DATA_SERVICE_URL;

    return <div>
        {
            props.data.chartType === 'PDFQAnalystViewV2'
                ? <PDFDataAnalystViewWrapperV2
                    {...props}
                    dataServiceUrl={dataServiceUrl}
                    loader={<Loader />}
                />
                : <PDFDataAnalystViewWrapper
                    {...props}
                    dataServiceUrl={dataServiceUrl}
                    loader={<Loader />}
                />
        }
    </div>
}

const mapDispatchToProps = {
    getNotDuplicateAPI,
    getContractDataById,
    updateDataModelData,
    clearSuccessMsg,
    createDocument,
    downloadSheet,
    deleteContractPDFAction,
    getModelDataDropDown,
    downloadContractPDFAction,
    getEventByID,
    initiateAction,
    getMembersList,
    clearReduxDataOfCurrentComponent,
    updateContractAnnotations,
    getDataModelById,
    getModelData,
    getAuditTrailsData,
    changeAssigneeRequest,
    completeReviewAction,
    addNewEntriesByDataModel,
    getDataModels,
    otherDocMove,
    splitPDF,
    getVISData,
    getPDFForOtherDoc,
    hideSuccessMessage,
    rejectReviewAction,
    getWorkflow,
    finalDocument,
    getGroupsByMemberId,
    getNextRespondent,
    getNextTasks,
    reInitiateWorkflow,
    executeWorkFlow,
    executeWorkFlowReject,
    lockDocument,
    unlockDocument,
    getGroups,
    fetchmasterDataForDataelementUsingRules,
    addComment,
    getSupportingDocuments,
    uploadSupportDocument,
    getOthersAuditTrailsData,
    moveToDuplicates,
    createDocumentTableData,
    getDocumentTablesDataById,
    updateDocumentTableData,
    deleteDocumentTableData,
    getLineItemsTablesData,
    getReviewInfo,
    executeRejectToQa,
    getPoInfoFromExternalSource,
    handleSageIntacct,
    getDocumentAnnotations,
    getCurrentStepRespondents,
    resolveIntegrationExceptions,
    uploadLITableExcel,
    supportingDocMove,
    archivedData
};

const mapStateToProps = state => {
    return {
        formData: state.form,
        action: state.action,
        appConfig: state.appConfig.app,
        PUBLIC_PATH: PUBLIC_PATH,
        members: state.appConfig.members,
        dataModels: state.dataModels,
        user: state.user,
        appConfiguration: state.form.document?.appConfig
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(PDFQAViewComponent));